import React from "react";

const CTASection = ({ data }) => {
    if (!data) return null;

    const { tagline, title, description, cta, styles } = data;

    return (
        <div
            style={{
                backgroundColor: styles?.background || "#f8f9fa",
                border: `2px solid ${styles?.borderColor || "#0d6efd"}`,
                textAlign: styles?.textAlign || "center"
            }}
        >
            {/* Tagline */}
            <div className="paragraph p-2"
                style={{
                    fontWeight: "600",
                    fontSize: styles?.taglineSize || "16px",
                    borderBottom: `2px solid ${styles?.borderColor || "#0d6efd"}`,
                }}
            >
                {tagline}
            </div>
            <div className="p-3">
                {/* Title */}
                <h5 className="paragraph"
                    style={{
                        fontWeight: "700",
                        fontSize: styles?.titleSize || "26px",
                        marginBottom: "20px"
                    }}
                >
                    {title}
                </h5>

                {/* Description */}
                <p className="paragraph"
                    style={{
                        fontSize: styles?.descSize || "16px",
                        lineHeight: "1.7",
                        maxWidth: "900px",
                        margin: "0 auto 20px"
                    }}
                >
                    {description}
                </p>

                {/* CTA Button / Link */}
                {cta?.text && (
                    <a
                        href={cta.link}
                        style={{
                            color: styles?.ctaColor || "#0d6efd",
                            fontWeight: "600",
                            fontSize: "18px",
                            textDecoration: "underline"
                        }}
                    >
                        {cta.text}
                    </a>
                )}
            </div>
        </div>
    );
};

export default CTASection;